import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

export type CustomersTree = {
    profiles: {
        registered: {
            list: () => void,
            detail: (id: any) => void,
            newAccount: (id: any) => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void,
            advancedSettings: (id, tab) => void
        },
        pending: {
            list: () => void,
            detail: (id: any) => void,
            details: (id: any, tab: any) => void,
            newAccount: (id: any) => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void
            advancedSettings: (id, tab) => void
        }
    }
};

export type TransactionsTree = {
    history: {
        detail: (id: any) => void
    },
    openbanking: {
        clients: {
            detail: (id: any) => void,
            newClient: () => void,
            updateClient: (id: any) => void,
            clientPayments: (id: any) => void
        },
        payments: {
            detail: (id: any) => void,
            newPayment: () => void,
            updatePayment: (id: any) => void
        }
    }
};

export type ApplicationsTree = {
    profiles: {
        new: {
            detail: (id: any) => void,
            list: () => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void,
            process: {
                form: (id: string) => void,
                success: (link: string, code: string) => void,
            },
            decline: (id: any) => void
        },
        declined: {
            detail: (id: any) => void,
            list: () => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void,
            approve: {
                form: (id: string) => void,
                success: (link: string, code: string) => void,
            },
            suspend: (id: any) => void
        },
        processing: {
            detail: (id: any) => void,
            list: () => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void,
            approve: {
                form: (id: string) => void,
                success: (link: string, code: string) => void,
            },
            decline: (id: any) => void
        },
        onhold: {
            detail: (id: any) => void,
            list: () => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void
        },
        archived: {
            detail: (id: any) => void,
            list: () => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void
        },
        manualreview: {
            detail: (id: any) => void,
            list: () => void,
            settings: (id, tab) => void,
            verification: (id, tab) => void
        }
    }
};

export type ConfigurationTree = {
    tariff: {
        list: () => void,
        detail: (id: any) => void,
        newTariff: () => void,
        updateTariff: (id: any) => void
    }
};

@Injectable()
export class NavigationService {

    readonly customers: CustomersTree;
    readonly transactions: TransactionsTree;
    readonly configuration: ConfigurationTree;
    readonly applications: ApplicationsTree;

    constructor(router: Router) {
        this.customers = {
            profiles: {
                registered: {
                    list: () => router.navigate(['space', 'customers', 'profiles', 'registered']),
                    detail: (id) => router.navigate(['space', 'customers', 'profiles', 'registered', id]),
                    newAccount: (id) => router.navigate(['space', 'customers', 'profiles', 'registered', id, 'account', 'new']),
                    settings: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'registered', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'registered', id, 'verification', tab]),
                    advancedSettings: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'registered', id, 'settings', tab])
                },
                pending: {
                    list: () => router.navigate(['space', 'customers', 'profiles', 'pending']),
                    detail: (id) => router.navigate(['space', 'customers', 'profiles', 'pending', id]),
                    details: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'pending', id, tab]),
                    newAccount: (id) => router.navigate(['space', 'customers', 'profiles', 'pending', id, 'account', 'new']),
                    settings: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'pending', id, tab]),
                    advancedSettings: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'pending', id, 'settings', tab]),
                    verification: (id, tab) => router.navigate(['space', 'customers', 'profiles', 'pending', id, 'verification', tab])
                }
            }
        };

        this.applications = {
            profiles: {
                new: {
                    detail: (id) => router.navigate(['space', 'applications', 'profiles', 'new', id]),
                    settings: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'new', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'new', id, 'verification', tab]),
                    list: () => {
                        router.navigate(['space', 'applications', 'profiles', 'new'])
                    },
                    process: {
                        form: (id) => router.navigate(['space', 'applications', 'profiles', 'new', 'approve', id]),
                        success: (link, code) => router.navigate(['space', 'applications', 'profiles', 'approve', 'success', link, code]),
                    },
                    decline: (id) => router.navigate(['space', 'applications', 'profiles', 'new', 'suspend', id])
                },
                declined: {
                    detail: (id) => router.navigate(['space', 'applications', 'profiles', 'declined', id]),
                    settings: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'declined', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'declined', id, 'verification', tab]),
                    list: () => {
                        router.navigate(['space', 'applications', 'profiles', 'declined'])
                    },
                    approve: {
                        form: (id) => router.navigate(['space', 'applications', 'profiles', 'declined', 'approve', id]),
                        success: (link, code) => router.navigate(['space', 'applications', 'profiles', 'approve', 'success', link, code]),
                    },
                    suspend: (id) => router.navigate(['space', 'applications', 'profiles', 'declined', 'suspend', id])
                },
                processing: {
                    detail: (id) => router.navigate(['space', 'applications', 'profiles', 'processing', id]),
                    settings: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'processing', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'processing', id, 'verification', tab]),
                    list: () => {
                        router.navigate(['space', 'applications', 'profiles', 'processing'])
                    },
                    approve: {
                        form: (id) => router.navigate(['space', 'applications', 'profiles', 'processing', 'approve', id]),
                        success: (link, code) => router.navigate(['space', 'applications', 'profiles', 'approve', 'success', link, code]),
                    },
                    decline: (id) => router.navigate(['space', 'applications', 'profiles', 'processing', 'suspend', id])
                },
                onhold: {
                    detail: (id) => router.navigate(['space', 'applications', 'profiles', 'onhold', id]),
                    settings: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'onhold', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'onhold', id, 'verification', tab]),
                    list: () => {
                        router.navigate(['space', 'applications', 'profiles', 'onhold'])
                    },
                },
                archived: {
                    detail: (id) => router.navigate(['space', 'applications', 'profiles', 'archived', id]),
                    settings: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'archived', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'archived', id, 'verification', tab]),
                    list: () => {
                        router.navigate(['space', 'applications', 'profiles', 'archived'])
                    },
                },
                manualreview: {
                    detail: (id) => router.navigate(['space', 'applications', 'profiles', 'manualreview', id]),
                    settings: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'manualreview', id, tab]),
                    verification: (id, tab) => router.navigate(['space', 'applications', 'profiles', 'manualreview', id, 'verification', tab]),
                    list: () => {
                        router.navigate(['space', 'applications', 'profiles', 'manualreview'])
                    },
                }
            }
        };

        this.transactions = {
            history: {
                detail: (id) => router.navigate(['space', 'history', 'transfers', 'details', id])
            },
            openbanking: {
                clients: {
                    detail: (id) => router.navigate(['space', 'open-banking', 'clients', 'details', id]),
                    newClient: () => router.navigate(['space', 'open-banking', 'clients']),
                    updateClient: (id) => router.navigate(['space', 'open-banking', 'clients', 'update', id]),
                    clientPayments: (id) => router.navigate(['space', 'open-banking', 'clients', 'payments', id])
                },
                payments: {
                    detail: (id) => router.navigate(['space', 'open-banking', 'payments', 'details', id]),
                    newPayment: () => router.navigate(['space', 'open-banking', 'payments']),
                    updatePayment: (id) => router.navigate(['space', 'open-banking', 'payments', 'update', id])
                }
            }
        };

        this.configuration = {
            tariff: {
                list: () => router.navigate(['space', 'configuration', 'tariffs']),
                detail: (id) => router.navigate(['space', 'configuration', 'tariffs', id]),
                newTariff: () => router.navigate(['space', 'configuration', 'tariffs']),
                updateTariff: (id) => router.navigate(['space', 'configuration', 'tariffs', 'update', id]),
            }
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/navigation/navigation.service.ts